import * as R from "ramda"

export const stringToBool = x => {
  if (R.type(x) === "String") {
    return x === "false" ? false : true
  }

  return x
}
